/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { Close, MoreHoriz } from '@material-ui/icons';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
  acceptABusinessPartner,
  acceptASchoolPartner,
  deleteABusinessPartner,
  deleteASchoolPartner,
  deleteClasse,
  getClassesById,
} from '@webapps/business';
import {
  Button,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ConfirmDialog from 'components/ConfirmDialog';
import MessageBox from 'components/MessageBox';
import Modal, { default as ModalStep } from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

const ActionsPartner = ({ info, refetch, type, accept }) => {
  const { classes, css, theme: { spacing }, } = useStyles(styles);

  const { addToast } = useToast();
  const { push } = useRouter();
  const { idUser } = useAuth();

  const [openConfirm, setOpenConfirm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const viewPartner = () => {
    push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id: info.id } });
  };
  
  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDelete,
  } = useMutation(deleteABusinessPartner);

  const resilePartner = async () => {
    await mutateDelete({
      businessId: idUser,
      schoolId: info.id,
    });
  };

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: accept ? 'Partenariat rompu' : type == "schoolToBusiness" ? "Partenariat annulé" : "Demande annulé",
      });
      refetch();
      setOpenConfirm(false);
    }
  }, [isSuccessDelete]);

  const [openMessageBox, setOpenMessageBox] = useState(false);

  return (
    <div>
      <ButtonBase onClick={handleClick} style={{ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' }}>
        <MoreHoriz fontSize="small" onClick={handleClick} style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        id="candidature-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{ elevation: 2 }}
        transformOrigin={{ horizontal: 'left', vertical: -50 }}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      >
        <MenuItem onClick={viewPartner}>Voir la vitrine</MenuItem>
        <MenuItem onClick={() => setOpenConfirm(true)}>{accept ? "Terminer le partenariat" : type == "schoolToBusiness" ? "Annuler le partenariat" : "Annuler la demande"}</MenuItem>
        <MenuItem onClick={() => setOpenMessageBox(true)}>Contacter l'école</MenuItem>
      </Menu>
      <Modal
        onCancel={() => setOpenMessageBox(false)}
        open={openMessageBox}
        title="Envoyez un message et retrouvez vos conversations dans la message"
        withStep={false}
      >
        <MessageBox id={info.id} onCancel={() => setOpenMessageBox(false)} />
      </Modal>
      <ConfirmDialog
        confirm={() => resilePartner()}
        handleCloseConfirmDialog={() => setOpenConfirm(false)}
        isLoadingConfirm={isLoadingDelete}
        openConfirm={openConfirm}
        title="Suppression du partenaire"
      >
        <div className={css({color: '#152652'})}>Êtes-vous sûr de vouloir {accept ? "terminer le partenariat ?" : type == "schoolToBusiness" ? "rompre le partenariat ?" : "annuler la demande ?"}</div>
      </ConfirmDialog>
    </div>
  );
};

const styles = ({ spacing }) => ({

});

ActionsPartner.propTypes = {
  id: PropTypes.number.isRequired,
  refetch: PropTypes.func,
  type: PropTypes.string,
};

export default ActionsPartner;
